import * as React from 'react';

import {SidebarSection} from 'shells/setup/sidebar-section/sidebar-section';
import type {SidebarSectionLink} from 'shells/setup/sidebar-section/sidebar-section';

import type {GetProductsCategories_productCategories as ProductCategory} from 'nutshell-graphql-types';

type Props = {
    isViewingArchived: boolean | null | undefined;
    selectedCategoryId: string | null | undefined;
    productCategories: ProductCategory[];
    numProducts: number;
    numUncategorizedProducts: number;
    numDeletedProducts: number;
};

export function ProductsSidebarSection(props: Props) {
    const links: SidebarSectionLink[] = [
        {
            to: `/sales/product`,
            label: `All`,
            isActive: !props.isViewingArchived && props.selectedCategoryId === undefined,
            count: props.numProducts,
        },
        {
            to: `/sales/product?category=null`,
            label: 'Uncategorized',
            isActive: props.selectedCategoryId === null,
            count: props.numUncategorizedProducts,
        },
    ];

    links.push(
        ...props.productCategories.map((category) => ({
            to: `/sales/product?category=${category.id}`,
            label: category.name,
            isActive: props.selectedCategoryId === category.id,
            count: category.numAssociatedProducts,
        }))
    );

    links.push(
        // @ts-expect-error
        ...[
            {
                to: `/sales/product?archived=true`,
                label: 'Archived',
                isActive: props.isViewingArchived === true,
                count: props.numDeletedProducts,
                type: 'archived',
            },
        ]
    );

    return <SidebarSection title='Categories' links={links} />;
}
